/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.55"
        height="18.69"
        viewBox="0 0 18.55 18.69"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M.3 14.01c0 .05 1.19 1.19 5.64 1.59a3.4 3.4 0 0 0 3.31 3.1 3.32 3.32 0 0 0 3.25-3.07c4.48-.34 5.65-1.31 5.7-1.35l.35-.31-2.4-3.2v-.26c0-2.07.07-6.36-2.33-8.78A6 6 0 0 0 9.37.03h-.18a6 6 0 0 0-4.45 1.69c-2.4 2.42-2.35 6.72-2.33 8.79v.26L.03 13.71Zm8.95 3.69a2.41 2.41 0 0 1-2.31-2h.15c.73 0 1.44.05 2.16.05h2.24a2.31 2.31 0 0 1-2.24 2Zm-5.86-6.59v-.6c0-1.93-.07-6 2-8.07a5 5 0 0 1 3.74-1.4h.21a5 5 0 0 1 3.74 1.4c2.11 2.07 2.11 6.07 2.11 8.07v.62l2 2.64c-.75.32-2.67.91-6.83 1H7.18a14.59 14.59 0 0 1-5.68-1.14Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BellIcon';

export default Icon;
